import { Redirect } from 'expo-router';

/** NotFound - redirects unknown routes back to the home screen. */
export default function NotFound() {
  return <Redirect href="/" />;
}
